module.exports={title:"New Account",description:"Get access to exclusive content by confirming your email after signing up."};